// extracted by mini-css-extract-plugin
export default {"AnimalForm":"AnimalFormBet_AnimalForm__Qkywz","AnimalLabel":"AnimalFormBet_AnimalLabel__zXmO-"};